/*
 * CAPTURE-OWNED MODULE
 * Document attributes: keys that describe the document as a whole and are
 * never a zone-able template field.
 *
 * document_type is a property of the template (capture_templates.document_type)
 * and of the classified document, not something read from a zone. Its library
 * association exists only so Library can show it, so Template Studio keeps it
 * out of the field list, the Field Library panel and the add paths, and shows
 * it read-only in the Document attributes section instead.
 *
 * The list is explicit on purpose. default_enabled = false is NOT a signal:
 * the Field Library page and the Publish node's new-field modal both create
 * custom fields with default_enabled = false, and those are ordinary fields.
 */

export const DOCUMENT_ATTRIBUTE_KEYS = Object.freeze(['document_type']);

/** True when a field key (template or library) is a document attribute. */
export function isDocumentAttributeKey(key) {
  if (typeof key !== 'string') return false;
  return DOCUMENT_ATTRIBUTE_KEYS.includes(key.trim().toLowerCase());
}
